import React from 'react'
import AssignmentIcon from '@mui/icons-material/Assignment'
import { IconProps } from './iconBase'

/** 利用履歴機能アイコン */
export const UsageHistoryIcon = (props: IconProps) => {
  return <AssignmentIcon {...props} />
}
